import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Image from '../../../../Core/Image';

export const MediaContainer = styled.div`
  z-index: 1;
  width: calc(100% - 40px);
  display: flex;
  flex-direction: row;
  bottom: 0;
  position: relative;
  margin: 2rem auto -6rem;
  overflow: hidden;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 38%;
    transform: translateX(50%);
    right: 50%;
    position: absolute;
    top: auto;
    right: 0;
    bottom: -5rem;
    left: auto;
    transform: none;
    margin: 0;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 45%;
    bottom: -6rem;
  }
`;

export const HeroImage = styled(Image)`
  height: 270px;
  width: 100%;
  margin: 0;
  height: auto;
  object-fit: contain;

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 0;
    height: 270px;
    height: 100%;
    width: 100%;
  }
`;

export const MotionWrapper = styled.div`
  position: relative;
  width: 100%;
  opacity: 0;
  animation-name: fadeIn;
  animation-delay: 1.5s;
  animation-duration: 1s;
  animation-timing-function: ease-out;
  animation-fill-mode: forwards;
  margin: 0 auto;

  &:nth-child(1) {
    z-index: 1;
    max-width: 200px;
    margin: 0 auto;

    /* @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-left: 37px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-left: 40px;
    } */

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      max-width: 249px;
      /* margin-left: 10%; */
    }
  }

  &:nth-child(2) {
    z-index: 2;
    max-width: 260px;
    position: absolute;
    left: 0;
    right: 0;
    top: 12%;
    margin: 0 auto;
    box-shadow: 0 6px 10px -3px rgba(0, 0, 0, 0.12);
    opacity: 0;
    transform: scale(0.5);
    animation-name: popOut;
    animation-delay: 3s;
    animation-duration: 1.4s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    /* @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-left: 2.4%;
    } */

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      max-width: 337px;
    }
  }

  &:nth-child(3) {
    z-index: 2;
    max-width: 260px;
    position: absolute;
    left: 0;
    right: 0;
    top: 28%;
    margin: 0 auto;
    transform: scale(0.5);
    box-shadow: 0 6px 10px -3px rgba(0, 0, 0, 0.12);
    opacity: 0;
    animation-name: popOut;
    animation-delay: 3.5s;
    animation-duration: 1.4s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    /* @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-left: 2.4%;
    } */

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      max-width: 337px;
    }
  }

  &:nth-child(4) {
    z-index: 2;
    max-width: 260px;
    position: absolute;
    left: 0;
    right: 0;
    top: 57.5%;
    margin: 0 auto;
    box-shadow: 0 6px 10px -3px rgba(0, 0, 0, 0.12);
    opacity: 0;
    transform: scale(0.5);
    animation-name: popOut;
    animation-delay: 4s;
    animation-duration: 1.4s;
    animation-timing-function: ease-out;
    animation-fill-mode: forwards;

    /* @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-left: 2.4%;
    } */

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      max-width: 337px;
    }
  }

  @-webkit-keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  @-webkit-keyframes popOut {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    10% {
      opacity: 1;
      transform: scale(0.5);
    }
    35% {
      opacity: 1;
      transform: scale(0.5);
    }
    80% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes popOut {
    0% {
      opacity: 0;
      transform: scale(0.5);
    }
    10% {
      opacity: 1;
      transform: scale(0.5);
    }
    35% {
      opacity: 1;
      transform: scale(0.5);
    }
    80% {
      opacity: 1;
      transform: scale(1.2);
    }
    100% {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const CardImg = styled(Image)`
  width: 100%;
  margin: 0 auto;
`;
